module.exports = __webpack_public_path__ + "static/WEDDING E&M-36-a4f02dfddfd7ad7bd65993c5ce55fe7e.jpg";